module.exports = vendor_d3276433b58c8a2853f4;


//////////////////
// WEBPACK FOOTER
// external "vendor_d3276433b58c8a2853f4"
// module id = YSwN
// module chunks = 0